const IconViewerComponent = {
    templateUrl: '/ui/iconViewer/iconViewer.tpl.html',
    controller: 'iconViewerController',
    bindings: {
        item: '<',
        userId: '<'
    }
};

angular.module('umCore')
    .component('uiIconViewer', IconViewerComponent);
